import { useEffect } from "react";
import { toast } from "sonner";

import { State } from "@/state";
import { Toaster } from "@/components/ui/sonner";

/**
 * What the app says in passing (``snackbarMessage``), as shadcn's toasts: up
 * for six seconds, the message cleared as it goes. That the page is out of
 * date is held until it is reloaded: nothing on it can refresh till then.
 */
export function Snackbar() {
  const snackbarMessage = State((state) => state.snackbarMessage);
  const isClientOutdated = State((state) => state.isClientOutdated);

  useEffect(() => {
    if (!snackbarMessage) return;
    const clear = () => State.getState().setSnackbarMessage("");
    toast(snackbarMessage, {
      duration: 6000,
      onAutoClose: clear,
      onDismiss: clear,
    });
  }, [snackbarMessage]);

  useEffect(() => {
    if (!isClientOutdated) return;
    toast(
      "Neoledger has been updated since this page was opened. Reload to carry on.",
      {
        id: "client-outdated",
        duration: Infinity,
        dismissible: false,
        action: { label: "Reload", onClick: () => window.location.reload() },
      },
    );
  }, [isClientOutdated]);

  return <Toaster position="top-center" />;
}
